import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatPaginator, MatSnackBar } from '@angular/material';
import { Organization } from '../../models/organization.model';
import { LocalUserService } from '../../services/localUser';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import * as moment from 'moment';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-user-details-dialog',
  templateUrl: './user-details-dialog.component.html',
  styleUrls: ['./user-details-dialog.component.scss']
})
export class UserDetailsDialogComponent implements OnInit {

  user: any;
  orgId: string;
  caseDetails = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  organizationList: any[] = [];
  selectedCase: any
  selectedCaseContacts: any
  displayedColumns: string[] = ['caseNo', 'name', 'created_date', 'view'];
  selectedTab = 'userDetails'
  constructor(
    private localUser: LocalUserService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<UserDetailsDialogComponent>,
    public userService: UserService,
    public snackBar: MatSnackBar,

  ) {
    this.caseDetails.paginator = this.paginator;

  }

  ngOnInit() {
    this.orgId = this.localUser.getOrganizationId();
    this.user = this.data.userDetails
    this.organizationList = this.data.orgList
    if (this.data) {
      this.caseDetails.data = this.data.caseDetails
      this.viewCaseDetails(this.caseDetails.data[0])
    }
  }
  ngAfterViewInit() {
    this.caseDetails.paginator = this.paginator;
  }

  ngOnChanges() {

  }

  getOrgDetails(orgId) {
    for (let i = 0; i < this.organizationList.length; i++) {
      if (this.organizationList[i].id === orgId) {
        return (this.organizationList[i].name) ? this.organizationList[i].name : this.organizationList[i].name;
      }
    }
  }

  currentForm(name) {
    switch (name) {
      case 'TWOTHREE':
        return '2.3';
      case 'TWOFOUR':
        return '2.4';
      case 'THREEFOUR':
        return '3.4';
      case 'THREEFIVE':
        return '3.5';
      default:
        return name;
    }
  }

  openCase(id) {
    this.dialogRef.close()
    this.router.navigate(['case', this.orgId, id]);
  }

  viewCaseDetails(item) {
    this.selectedCaseContacts = null
    this.selectedCase = null
    this.selectedCase = item

    let contacts = this.selectedCase.contacts;
    let contactIds = []
    contacts.forEach(item => {

      if (item.user_id!=null &&  !contactIds.includes(item.user_id)){
        contactIds.push(item.user_id)
      }
      
    })

    this.userService.getMultipleUserDetails(contactIds).subscribe(result => {
     this.selectedCaseContacts = result
    },
    error => {
      const errorMessage = 'This page had an error please refresh if this continues contact support';
      this.snackBar.open(errorMessage, '', {
        duration: environment.snackBarErrorLength,
      });
    });
  }


  getColor(item) {
    return (item == this.selectedCase ? 'lightgray' : 'white')
  }


}



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/user-details-dialog/user-details-dialog.component.ts